export default __webpack_public_path__ + "static/media/undraw_forgot_password.8cfdbfab.svg";